import React from 'react';

import {
  PortfolioChartPresenter,
  PortfolioChartPresenterProps,
} from './PortfolioChartPresenter';

export type PortfolioChartContainerProps<
  Id extends number | string
> = PortfolioChartPresenterProps<Id>;

export const genProps = () => {
  type Id = 1 | 2 | 3 | 4 | 5;
  const genRGB = () => 256 * Math.random();
  return {
    idToTitle: (id: Id) => `id: ${id}`,
    idToColor: (id: Id) => `rgb(${genRGB()}, ${genRGB()}, ${genRGB()})`,
    data: [
      { id: 1, value: 30 },
      { id: 2, value: 30 },
      { id: 3, value: 30 },
      { id: 4, value: 5 },
      { id: 5, value: 5 },
    ] as { id: Id; value: number }[],
    valueFormatter: (number: number) => `${number}%`,

    chart: {
      title: '現在',
    },
  };
};

export const PortfolioChartContainer = <Id extends number | string>(
  props: PortfolioChartContainerProps<Id>
): React.ReactElement => {
  return <PortfolioChartPresenter {...props} />;
};

PortfolioChartContainer.genProps = genProps;
